var _style, _path, _path2, _path3, _linearGradient, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle2, _path41, _path42, _path43, _path44, _path45, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlustraFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ilustra-faq_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 381.7 284.1",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ilustra-faq_svg__st0{fill:none;stroke:#d1d3d4;stroke-width:2.5761;stroke-miterlimit:10}.ilustra-faq_svg__st4,.ilustra-faq_svg__st6{fill-rule:evenodd;clip-rule:evenodd;fill:#20c4f4}.ilustra-faq_svg__st6{opacity:.5;fill:#7ed3f7}.ilustra-faq_svg__st8{fill:#fff}.ilustra-faq_svg__st11,.ilustra-faq_svg__st8,.ilustra-faq_svg__st9{fill-rule:evenodd;clip-rule:evenodd}.ilustra-faq_svg__st9{opacity:.5;fill:#fff}.ilustra-faq_svg__st11{fill:#113c64}.ilustra-faq_svg__st15{fill:#5e9cd4}.ilustra-faq_svg__st15,.ilustra-faq_svg__st31,.ilustra-faq_svg__st32,.ilustra-faq_svg__st37{fill-rule:evenodd;clip-rule:evenodd}.ilustra-faq_svg__st31,.ilustra-faq_svg__st32{fill:#1d3361}.ilustra-faq_svg__st32{opacity:.3}.ilustra-faq_svg__st37{opacity:.35;fill:#a7c1e5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st0",
    d: "M162.1 23h-2.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6 23H44.1a5.7 5.7 0 00-5.7 5.7v183.2c0 3.2 2.6 5.7 5.7 5.7h5.3",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 2.58,
    strokeMiterlimit: 10,
    strokeDasharray: "4.6968,2.1349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st0",
    d: "M50.5 217.7h2.3"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.12,
    y1: 233.53,
    x2: 69.25,
    y2: 17.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8 46.8H312c6.2 0 11.3 5.3 11.3 11.8v182.9c0 6.5-5.1 11.8-11.3 11.8H66.8c-6.2 0-11.3-5.3-11.3-11.8v-183c.1-6.4 5.1-11.7 11.3-11.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_1_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312 46.8H66.8c-6.2 0-11.3 5.1-11.3 11.3v3.6h267.7V58c.1-6.2-5-11.2-11.2-11.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#279cd8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M89.9 52.2a2.9 2.9 0 100 5.8 2.9 2.9 0 000-5.8zm-10.1 0a2.9 2.9 0 100 5.8 2.9 2.9 0 000-5.8zm-10 0a2.9 2.9 0 100 5.8 2.9 2.9 0 000-5.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 148.1c-1 .5-2.3.1-2.8-.9s-.1-2.3.9-2.8c7.1-3.6 10.1-8.7 12.7-13.3 2-3.5 3.9-6.7 7.1-9 2.7-1.9 6.4-3.4 10.4-3.6 3.3-.2 6.9.5 10.1 2.6 3.5 2.2 5.7 4.9 6.9 7.7 1.6 3.5 1.8 7.1 1.3 10.2-.1 1-.4 2.1-.7 3.4-1.5 7-3.9 18.6 7.5 22.1 1.1.3 1.7 1.5 1.4 2.6-.3 1.1-1.5 1.7-2.6 1.4-15.1-4.6-12.2-18.6-10.4-27 .3-1.2.5-2.3.6-3.2.4-2.4.2-5.2-1-7.9-1-2.1-2.7-4.1-5.4-5.9-2.4-1.5-5-2-7.6-1.9-3.2.2-6.1 1.3-8.2 2.8-2.5 1.8-4.1 4.6-5.9 7.7-2.8 5.2-6.1 10.9-14.3 15zm19 26.7c2.5-2.4 5-4.8 7-5.2 1.7-.3 3.4 1.2 5.2 6.2a2.12 2.12 0 104-1.4c-2.8-7.5-6.2-9.5-9.9-8.9-3.3.6-6.4 3.5-9.3 6.3-.8.8-.8 2.2 0 3 .8.8 2.1.9 3 0zm14.8-20.6c-1.6 3.9-1.5 8 .2 11.7 1.6 3.4 4.6 6.4 9 8.3 1.1.5 2.3 0 2.8-1.1s0-2.3-1.1-2.8c-3.4-1.5-5.7-3.7-6.9-6.3a10 10 0 01-.1-8.3c.4-1.1-.1-2.3-1.2-2.8-1-.3-2.2.2-2.7 1.3zm-6.9-17.5c-.2 1.1-3.7 7.1-10.3 14.1-4 4.3-9.2 8.9-15.4 12.8a2 2 0 00-.6 2.9 2 2 0 002.9.6c6.5-4.2 12-9 16.2-13.5 7.2-7.7 11.2-14.9 11.4-16.3.2-1.2-.6-2.2-1.7-2.4-1.3-.1-2.4.6-2.5 1.8zm-27.3 22c3.3-1.9 6.5-4.1 9.5-6.5 3.1-2.4 5.9-5.1 8.2-8.1 1.4-1.8 2.5-4 3.5-6.2 2.1-4.3 4.2-8.6 9.1-7.4 2.1.5 3.4 1.5 4.1 2.7.8 1.2 1 2.8 1 4.4 0 3.7-3.5 9.3-8.4 14.9-6 7-13.9 13.7-19.4 16.8-1 .6-1.4 1.9-.8 2.9.6 1 1.9 1.4 2.9.8 5.9-3.3 14.3-10.4 20.6-17.7 5.4-6.3 9.4-12.8 9.4-17.6 0-2.3-.4-4.6-1.6-6.6-1.3-2.1-3.4-3.7-6.7-4.6-8.2-2-11 3.8-13.9 9.6-1 1.9-1.9 3.9-3.1 5.4-2.1 2.7-4.7 5.2-7.5 7.4s-5.9 4.3-9.1 6.1c-1 .6-1.3 1.9-.7 2.9.6 1.1 1.9 1.4 2.9.8zm4.9-49.7c-.7.9-2 1.1-3 .4-.9-.7-1.1-2-.4-3 1.6-2 3.4-3.8 5.3-5.4 6.7-5.3 15.3-7.8 23.9-7.5 8.6.2 17.2 3.1 24.1 8.5 2.2 1.7 4.3 3.8 6.1 6 .7.9.6 2.2-.3 3-.9.7-2.2.6-3-.3-1.6-2-3.4-3.8-5.4-5.3a36.8 36.8 0 00-21.6-7.6c-7.7-.2-15.3 1.9-21.2 6.6-1.6 1.3-3.1 2.9-4.5 4.6zm-3.1 16.2c.2-.3.3-.6.4-.8 4.4-7.7 10.9-13.4 18.2-16.1 7.2-2.7 15.2-2.5 22.7 1.7l.6.3c6.8 3.9 10.7 9.4 12.6 15.7 2.4 7.7 1.8 16.5-.4 24.9-.3 1.1.4 2.3 1.5 2.6 1.1.3 2.3-.4 2.6-1.5 2.3-9.1 3-18.7.3-27.2-2.2-7.2-6.8-13.6-14.6-18.1-.3-.1-.5-.3-.6-.4-8.7-4.7-17.9-5-26.2-1.9-8.2 3.1-15.5 9.4-20.4 17.9-.2.3-.3.6-.5.9-.6 1-.2 2.3.8 2.9 1.2.5 2.5.2 3-.9zm-1.5 12.3c3.9-2.5 6.7-6.4 9.5-10.3 2.4-3.4 4.9-6.8 8-9 2.9-2 7.1-3.5 11.6-3.6 3.8-.1 7.8.8 11.3 3 4 2.6 6.5 5.5 7.9 8.5 1.7 3.6 2 7.4 1.4 10.7-1 6.1-1.6 10.6-1.1 14.5.6 4.2 2.5 7.5 6.5 11 .9.8 2.2.7 3-.2.8-.9.7-2.2-.2-3-3.1-2.7-4.6-5.3-5.1-8.4-.5-3.3.1-7.5 1-13.2.7-4.1.4-8.7-1.8-13.3-1.8-3.7-4.7-7.2-9.4-10.2-4.3-2.7-9.1-3.8-13.7-3.7-5.4.1-10.4 1.9-13.9 4.4-3.7 2.6-6.3 6.3-9 10-2.6 3.6-5.1 7.1-8.3 9.2a2 2 0 00-.6 2.9c.6 1.1 1.9 1.4 2.9.7z",
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b9e5fb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M159.3 142.9c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M159.3 144.5c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M170.1 133.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2-.1-1.7 1.4-3.2 3.2-3.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M170.1 134.9c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .7-1.7 1.7-1.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M178.5 121.4c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M178.5 122.9c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7.1-.9.8-1.7 1.7-1.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M192.5 117.4c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2-.1-1.8 1.4-3.2 3.2-3.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M192.5 118.9c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.7-1.7 1.7-1.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M203.4 124.9c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M203.4 126.5c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7c0-1 .8-1.7 1.7-1.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M204.1 139.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M204.1 140.8c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M203.2 152c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M203.2 153.5c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M212.4 163.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M212.4 164.8c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7.1-.9.8-1.7 1.7-1.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M159.6 121c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M159.6 122.5c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M170.5 107.8c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M170.5 109.3c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 188.91 104.35)",
    className: "ilustra-faq_svg__st6",
    cx: 188.9,
    cy: 104.3,
    r: 3.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M188.9 102.7c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M209.5 108.4c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M209.5 109.9c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7.1-.9.8-1.7 1.7-1.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M219.5 127.4c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.7 1.5-3.2 3.2-3.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M219.5 129c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7c.1-1 .8-1.7 1.7-1.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M217.6 148.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2-.1-1.8 1.4-3.2 3.2-3.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M217.6 149.8c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.7-1.7 1.7-1.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M196.3 162.1c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M196.3 163.6c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M178.7 169.6c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M178.7 171.1c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7.1-1 .8-1.7 1.7-1.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M192.6 171c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2-.1-1.7 1.4-3.2 3.2-3.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M192.6 172.6c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .7-1.7 1.7-1.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-76.77 163.8 165.31)",
    className: "ilustra-faq_svg__st6",
    cx: 163.8,
    cy: 165.3,
    r: 3.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M163.8 163.6c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M189 133.9c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M189 135.4c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M178 149.6c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M178 151.1c.9 0 1.7.8 1.7 1.7s-.8 1.7-1.7 1.7c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M176.5 94.5c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M176.5 96c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st6",
    d: "M204.1 94.7c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M204.1 96.2c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7c0-.9.8-1.7 1.7-1.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.83,
    y1: 3.48,
    x2: 194.18,
    y2: 30.79
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20c4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279cd8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.2 13c1.2-.6 2.5-.9 3.9-.9 5.5 0 10 4.9 10 10.9 0 6.3-4.2 10.9-10 10.9h-35c-5.7 0-10-4.6-10-10.9 0-6 4.5-10.9 10-10.9 1.4 0 2.7.3 3.9.9.5-7.1 6.4-12.7 13.6-12.7 7.2 0 13.1 5.6 13.6 12.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M186.1 19.1v11h-4.4v-11h-4l6.2-9.6 6.2 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M193 20.5v-11h4.4v11h4l-6.2 9.6-6.1-9.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st9",
    d: "M189.4 62.3c7.6 0 13.8 6.2 13.8 13.8 0 7.6-6.2 13.8-13.8 13.8-7.6 0-13.8-6.2-13.8-13.8 0-7.7 6.2-13.8 13.8-13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4 71.1c1.2 0 2.3.3 3.3.8v-2.1c0-.1-.1-.2-.1-.3-.1-.1-.2-.1-.3-.1h-5.8c-.1 0-.2.1-.3.1-.1.1-.1.2-.1.3v2.1c1-.5 2.1-.8 3.3-.8zm6.3 3.5c.7 1.1 1 2.4 1 3.8 0 4-3.3 7.3-7.3 7.3s-7.3-3.3-7.3-7.3c0-1.4.4-2.7 1-3.8v-4.8c0-.9.4-1.8 1-2.4.6-.6 1.5-1 2.4-1h5.8c.9 0 1.8.4 2.4 1 .6.6 1 1.5 1 2.4v4.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffcb05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st11",
    d: "M189.4 76.8c.8 0 1.5.7 1.5 1.5 0 .5-.2.9-.6 1.2v2.7c0 .5-.4.9-.9.9a.9.9 0 01-.9-.9v-2.7c-.3-.3-.6-.7-.6-1.2.1-.8.7-1.5 1.5-1.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.06,
    y1: 250.18,
    x2: 188.64,
    y2: 174.48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.3 181.3h94.2c2.3 0 4.2 2.1 4.2 4.6v60.8c0 2.5-1.9 4.6-4.2 4.6h-94.2c-2.3 0-4.2-2.1-4.2-4.6v-60.8c0-2.6 1.9-4.6 4.2-4.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1 181.4h89.8c2.2 0 4 1.9 4 4.3v56.8c0 2.3-1.8 4.3-4 4.3h-89.8c-2.2 0-4-1.9-4-4.3v-56.8c0-2.4 1.8-4.3 4-4.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d1e5f6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M148.1 210.6h77.8c2.8 0 5.2 2.2 5.2 4.8v4.4c0 2.7-2.3 4.8-5.2 4.8h-77.8c-2.8 0-5.2-2.2-5.2-4.8v-4.4c0-2.6 2.4-4.8 5.2-4.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.17,
    y1: 221.51,
    x2: 226.84,
    y2: 212.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 217.7,
    r: 6.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M220.5 214.2l4.1 4 2.5-2.7h.7l-3.8 5.7-4.7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st15",
    d: "M148.7 221.2l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.8 0L157 220c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.6 1-1.4-2.3c-.5.8-.9 1.6-1.5 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.6 1-1.4-2.3-1.5 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M148.1 188.5h77.8c2.8 0 5.2 2.2 5.2 4.8v4.4c0 2.7-2.3 4.8-5.2 4.8h-77.8c-2.8 0-5.2-2.2-5.2-4.8v-4.4c0-2.6 2.4-4.8 5.2-4.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.17,
    y1: 199.4,
    x2: 226.84,
    y2: 190.23
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 195.6,
    r: 6.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M220.5 192.1l4.1 4 2.5-2.7h.7l-3.8 5.7-4.7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st15",
    d: "M148.7 199.1l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.8 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.6 1-1.4-2.3c-.5.8-.9 1.6-1.5 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.6 1-1.4-2.3-1.5 2.4zm9.9 0l-1.5-1.2c.5-.6 1-1.1 1.5-1.6l.4-.4c-.2 0-.7-.1-1.4-.3-.6-.1-1-.2-1.1-.3l.6-1.8c.9.4 1.7.8 2.4 1.2-.2-1.1-.2-2-.2-2.7h1.8c0 .5-.1 1.4-.3 2.7.1-.1.4-.2.9-.4.6-.3 1.2-.5 1.7-.7l.5 1.8c-.7.2-1.6.3-2.6.5l1.2 1.4c.2.3.4.5.6.7l-1.5 1-1.4-2.3c-.6.8-1.1 1.6-1.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st4",
    d: "M165.3 229.6h43.4c2.8 0 5.2 2.2 5.2 4.8v4.4c0 2.7-2.3 4.8-5.2 4.8h-43.4c-2.8 0-5.2-2.2-5.2-4.8v-4.4c0-2.6 2.4-4.8 5.2-4.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.92,
    y1: 99.06,
    x2: -70.27,
    y2: 79.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 67.2h81.8v52.5h-81.8c-6 0-11-4.9-11-10.8v-30c0-6.4 4.9-11.7 11-11.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M335.9 77.8V105c0 5.4-4.7 9.8-10.5 9.8h-80.1c-5.8 0-10.5-4.4-10.5-9.8V77.8h101.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.34,
    y1: 70.53,
    x2: 284.65,
    y2: 84.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 67.2h80.1c5.8 0 10.5 4.7 10.5 10.5v3.4H234.7v-3.4c0-5.7 4.8-10.5 10.5-10.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st8",
    d: "M244.7 72.3a2.8 2.8 0 110 5.6 2.8 2.8 0 110-5.6zm9.7 0a2.8 2.8 0 110 5.6 2.8 2.8 0 01-2.8-2.8c0-1.5 1.3-2.8 2.8-2.8zm9.8 0a2.8 2.8 0 110 5.6 2.8 2.8 0 110-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9 90h44.4c1.1 0 2 .8 2 1.8v3.9c0 1-.9 1.8-2 1.8h-44.4c-1.1 0-2-.8-2-1.8v-3.9c0-1 .9-1.8 2-1.8zm-1.1 11.1H331c.5 0 1 .4 1 1v2.1c0 .5-.4 1-1 1h-61.2a1 1 0 01-1-1v-2.1c.1-.6.5-1 1-1z",
    opacity: 0.2,
    fill: "#20c4f4",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.83,
    y1: 94.33,
    x2: 251.65,
    y2: 98.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 83.7c7.7 0 13.9 6.2 13.9 13.9s-6.2 13.9-13.9 13.9-13.9-6.2-13.9-13.9 6.2-13.9 13.9-13.9zm0 7.4c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_8_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.53,
    y1: 92.83,
    x2: 250.99,
    y2: 100.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 88.9a8.7 8.7 0 11-.01 17.41 8.7 8.7 0 01.01-17.41zm0 3.7c-2.7 0-5 2.2-5 5 0 2.7 2.2 5 5 5 2.7 0 5-2.2 5-5 0-2.7-2.2-5-5-5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_9_)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.88,
    y1: 157.23,
    x2: 96.72,
    y2: 72.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d4f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed3f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.6 80.1H130c5.1 0 9.2 4.4 9.2 9.7v58.7c0 5.3-4.2 9.7-9.2 9.7H55.6V80.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_10_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.06,
    y1: 94.36,
    x2: 71.41,
    y2: 148.51
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#279cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d4f80"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 80.1h96.4c4.9 0 8.8 4.2 8.8 9.3v53.9c0 5.1-4 9.3-8.8 9.3H28.9c-4.8 0-8.8-4.2-8.8-9.3V89.4c0-5.1 4-9.3 8.8-9.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st9",
    d: "M27.4 137.7h99.5c.9 0 1.6.7 1.6 1.6v3.5c0 .9-.7 1.6-1.6 1.6H27.4c-.9 0-1.6-.7-1.6-1.6v-3.5c0-.9.7-1.6 1.6-1.6zm0-14.7h99.5c.9 0 1.6.7 1.6 1.6v3.5c0 .9-.7 1.6-1.6 1.6H27.4c-.9 0-1.6-.7-1.6-1.6v-3.5c0-.9.7-1.6 1.6-1.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.13,
    y1: 95.32,
    x2: 112.79,
    y2: 108.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeef8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.2 87.4h27.6c2 0 3.6 1.7 3.6 3.8v22.1c0 2.1-1.6 3.8-3.6 3.8H97.2c-2 0-3.6-1.7-3.6-3.8V91.2c0-2.1 1.6-3.8 3.6-3.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_12_)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.9 119.2c-2.1 2-4.3 3.8-5.8 5.8-12.8 16.5-3.3 31.8 26.1 25.9-3.3-20.6-7.1-15.7-20.3-31.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#002546"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.52,
    y1: 152.67,
    x2: 104.71,
    y2: 131.69
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1673ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1a83b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#20a4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#25b9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20c4f4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.6 137.2c-1 10.8 9.8 18 31.6 13.7-2.5-15.8-5.3-16.6-12.4-23.3l-8.4 3.8c-.7 5.1-1.4 9.9-1.9 15-5.1-2.2-7.7-4.4-8.9-9.2z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_13_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.61,
    y1: 113.78,
    x2: 173.2,
    y2: 121.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8a69a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.9 122.8c2-1.9 2.7-2.1 3.7-4.7 1-2.3 2.7-3.5 4.5-4.8 1.8-1.3 2.4-2.6 3.9-4 2-1.9 2.7-.1 1.3 1.8l-2.4 3.3c1.4 3.3 3.1 3.5 1.9 5.6-.7 1.3-2.5 3-3.6 3.6-2.8 1.6-2-.4-5.8 3.1-2.2-1.4-2.3-1.6-3.5-3.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_14_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.16,
    y1: 109.66,
    x2: 126.03,
    y2: 106.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8a69a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118 110.9c.1 1.4.1 3.4-.9 4.7.5 3.3 2.8 5.7 5.7 5.7 2.6 0 3.9-3.8 3.3-6 0-.7 0-1.3.1-1.9 1.2-.2 1.8-1 2.2-2.1 1.4-4.1.4-8.4-.1-12.6-3.1.9-5.4-.4-8.2-1.6-1.3-.6-1.7.3-1.9 1.4-.3 1.1-.5 1.5-1.8 2.7 1.7 6.7-.1 4.6-.9 3.4-.6-.9-1.5-.1-1.4 1.2.1 1.5 1.7 2 2.6 3 .4.4.6.7.8 1 .1.2.2.6.5 1.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_15_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.33,
    y1: 95.05,
    x2: 121.92,
    y2: 99.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a2e69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24093d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117 108.7c-1.6.4-2.1-.1-2.5-1.2-.5-1.1-.4-.8-1.2-1.6-.4-.4-.6-.8-.8-1.2-.6-1.4-.4-2.2-.5-3.3-.1-1.3-.7-1.8-1-2.6-1.4-4.1 1.9-7.9 6-6.3 1.2-2.6 3.5-2.8 5.6-1.8 2.3-1.6 4.6-1.6 6.3.2 3.4 3.4.7 7.1-1.4 8.2l-6.9 11.8-3.6-2.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 112c-1.4-1.4-2.8-3.8-3.1-4.5-.5-1.1-.4-.8-1.2-1.6-.4-.4-.6-.8-.8-1.2 3.5 2.5 7.8 7.6 8.3-1.6.1-1.6.7-3.9 2.3-4.6 1.8-.7 4-.2 7.3-3.8-.1 1.2-.6 2.3-1.3 3.1-1.8 2.1-2.7 4.7-3.3 7-.8 3-1.2 5.8-2.4 7.3-1.3 1.7-4.3 1.4-5.8-.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#24093d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st31",
    d: "M86.7 262l13.5.2c.7-.7.9-3.2.1-4.2-1-1.5-1.6-3.1-1.7-4.6l-5.1.2-2.2-1c-1 1.2-3.1 3.5-4.5 5.5-.7 1.1-.5 2.9-.1 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st32",
    d: "M99.2 256.4c-.2-.9-.5-1.9-.5-3l-5.1.2-2.2-1c-.4.5-.9 1.1-1.6 1.9 2 2.1 8.1 3.2 9.4 1.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.87,
    y1: 203.91,
    x2: 116.51,
    y2: 236.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#245ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203d74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.6 164.7c-1.2 3.8-2.9 6.6-4.6 14.3-1.9 8.4-2.4 16.3-3.8 24.4-2.7 15.9-6.2 32.1-10.9 49.3 2.8 2.3 8.2 2.3 10.1 1.6 5.9-13.4 9.5-26.5 14.7-40 7.1-18.6 14.8-37.2 21-54.9l-26.5 5.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_17_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.83,
    y1: 203.15,
    x2: 120.59,
    y2: 236.51
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e4896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3486"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.9 164.5c-2.8 8.4-18.4 69.2-20.5 89.9 5.9-13.4 9.5-26.5 14.7-40 7.1-18.6 14.8-37.2 21-54.9l-15.2 5z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st31",
    d: "M125.8 251.6c-.4 2.1-1.7 3.7-1.9 5.2-.3 2.6 1.2 5.3 4.3 5.3l20.3.2c-1.1-6.9-11.9-3.1-15.6-10.8l-4.7.3-2.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st32",
    d: "M125.8 251.6c-.1.7-.4 1.3-.6 1.9 1.9 1.3 5.6 2.2 9.8.8-.8-.7-1.5-1.6-2.1-2.8l-4.7.3-2.4-.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.33,
    y1: 202.15,
    x2: 133.25,
    y2: 237.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#245ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203d74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.7 163c.8 5 1.1 9.7 1 15.9-.3 23.3-4 49.6-6.5 72.8-3.3 1.3-7 1.2-9.7.1-.4-13.5-.6-27.8-2-41-2.3-22-11.3-37.4-6-50.4l15.7-.5 7.5 3.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st11",
    d: "M102.5 123.1c-5.4 7.3 3.3 7.6 4 13.2 1.4 12.7 2 21.3-.3 34.3 14.4 5.2 26.9 3.3 34.8.1-.3-11.8-1.4-19.9-1.7-31.4v-1.1c5.5 3.8 12.8 7.8 18.5 4.8 5.8-3.1 11.8-11.8 15.7-17.4-.7-2-3.3-5-4.6-5.1-7.1 5.2-10.5 9.5-14.8 10.4-4.4.9-13.9-15.8-23-16.5-.8-.1-1.6-.1-2.3-.1-5.6.2-10.6.3-15.4 1.7-4 1.1-8 3.2-10.9 7.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ilustra-faq_svg__SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.87,
    y1: 142.76,
    x2: 154.21,
    y2: 123.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1673ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1a83b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#20a4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#25b9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20c4f4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.3 138.5v-.4c5.5 3.8 12.8 7.8 18.5 4.8 5.8-3.1 11.8-11.8 15.7-17.4-7.7 6.2-18.8 26-36.8 3.7 1.2 4 1.3 5.6 2.6 9.3z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#ilustra-faq_svg__SVGID_20_)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ilustra-faq_svg__st37",
    d: "M190.7 283.7c105.2 0 190.5-8.8 190.5-19.6s-85.3-19.6-190.5-19.6S.2 253.3.2 264.1s85.3 19.6 190.5 19.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ilustra-faq_svg__st37",
    cx: 185.4,
    cy: 263.1,
    rx: 132.6,
    ry: 5.7
  }))));
}
export default __webpack_public_path__ + "static/ilustra-faq.fd93bb5e.svg";
export { SvgIlustraFaq as ReactComponent };